import "bootstrap/dist/css/bootstrap.min.css";
import io from "socket.io-client";
import Routes from "./routes";
import UpdateDetector from "./components/UpdateDetector";
import config from './services/config';
import { CorrecaoProvider } from './context/correcao';

const socket = io(config.server.hostname); 
 
function App() {
  return (
    <CorrecaoProvider>
      <UpdateDetector />
      <Routes socket={socket} />
    </CorrecaoProvider>
  );
}

export default App;